import React from "react"
import PropTypes from "prop-types"

import ApplicationSelect from "./ApplicationSelect"
import TicketSubject from "./TicketSubject"
import TicketCommentForm from "./TicketCommentForm"
import PrioritySelect from "./PrioritySelect"
import SubmitButton from "./SubmitButton"
import FreeAppRedirect from "./FreeAppRedirect"
import TicketFormContext from "./context/TicketFormContext"

class TicketForm extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      category: (this.props.form || {}).category || this.props.category,
      app: undefined,
      app_name: undefined,
      database: undefined,
      permission_granted: false,
      ticket: {
        phonenumber: this.props.phonenumber || "", // Modified state to handle ticket[phonenumber]
        timezone: this.props.timezone || "",
      },
      run_rate: undefined,
      form_type: (this.props.form || {}).form_type || this.props.form_type,
      app_vip: window.help.const.app_vip,
      permission_granted: false,
      current_macro_placement: "",
      macro_step: 0,
      macro_name: "",
      reading_macro: false,
      blocked_addon: false,
      addon_support_email: undefined,
      macro_dismissed: false,
      errors: {} // Initialize errors as an empty object
    };
  }

  formTypes () {
    return [
      { app: false, _haddon: false, _3addon: false, required_app: false },
      { app: true, _haddon: false, _3addon: false, required_app: true },
      { app: true, _haddon: true, _3addon: false, required_app: true },
      { app: true, _haddon: false, _3addon: true, required_app: true },
      { app: true, _haddon: false, _3addon: false, required_app: false },
      { app: true, _haddon: true, _3addon: true, required_app: true } // add this as a 5th form type to see if it adds postgreSQL addons. will remove later if this works.
    ]
  }

  getRunRate = (uuid) => {
    if (!this.props.restrict_node) { return false }
    var _this = this;
    SupportApiRequest({
      url: '/runrate/' + uuid + '/' + window.help.const.user_id,
      success: function(data) {
        _this.setState({run_rate: true});
      },
      error: function(data) {
        _this.setState({run_rate: false});
      }
    })
  }

  updateState = (data) => {
    this.setState(data);
  }

  validateForm = () => {
    const { timezone, ticket } = this.state;
    const errors = {};

    if (!timezone.trim()) {
      errors.timezone = "Timezone can't be blank.";
    } else {
      const validTimezones = Intl.supportedValuesOf("timeZone");
      if (!validTimezones || !validTimezones.includes(timezone)) {
        errors.timezone = "Please select a valid timezone.";
      }
    }

    if (ticket.phonenumber && !/^\+?[1-9]\d{1,14}$/.test(ticket.phonenumber)) {
      errors.phonenumber = "Invalid phone number format.";
    }

    this.setState({ errors });
    return Object.keys(errors).length === 0;
  };

  handleSubmit = (e) => {
    e.preventDefault();
    if (this.validateForm()) {
      // Submission logic here
    }
  };

  dispatch = (action, e = null) => {
    if (e) e.preventDefault();
    switch(action.type) {
      case 'CHANGE_MACRO_PLACEMENT':
        this.setState({ current_macro_placement: action.current_macro_placement });
        break;
      case 'SET_MACRO_NAME':
        this.setState({ macro_name: action.macro_name });
        window.doppler.track('click', { 'click_type': 'Show Macro', 'event': 'show_macro', 'event_location': 'new_ticket_form', 'macro_name': action.macro_name });
        window.dataLayer.push({'event': 'trackEvent', 'eventCat': 'new_ticket_form', 'eventAction': 'show_macro', 'eventLabel': action.macro_name});
        break;
      case 'CHANGE_MACRO_STEP':
        if (this.state.macro_step > action.macro_step) {
          this.setState({ macro_step: action.macro_step, farthest_macro_step: this.state.macro_step });
        } else {
          this.setState({ macro_step: action.macro_step });
        }
        break;
      case 'READING_MACRO':
        this.setState({ reading_macro: true });
        break;
      case 'DONE_READING_MACRO':
        this.setState({ reading_macro: false });
        break;
      case 'DISMISS_MACRO':
        this.setState({ macro_dismissed: true });
        break;
      default:
        new Error('This should not be reached.');
    }
  }

  renderSubForm = (components) => {

    if (this.state.blocked_addon) {

      components.push(
        <div className="flex items-center hk-message--danger mt2" key="blockedAddon">
          <div className="flex-auto">
            <div className="f4 b lh-title pt2">Direct Support Add-on</div>
            <div className="lh-copy">
              <p>This add-on partner provides support for its add-on directly. Heroku Support cannot assist directly with issues related to this add-on, including errors when creating or upgrading the add-on.</p>
              <p>To get help with this add-on, please email <a href={'mailto:' + this.state.addon_support_email}>{this.state.addon_support_email}</a>.</p>
            </div>
          </div>
        </div>
      )
      return components;

    } else {

      if (this.props.restrict_node && this.formTypes()[this.state.form_type].app) {
        if ($('#app').val() === undefined) {
          return components;
        } else if (this.state.run_rate === false) {
          components.push(<FreeAppRedirect />)
          return components;
        }
      }

      if (!this.formTypes()[this.state.form_type].app && this.props.restrict_node && this.props.free_user) {
        components.push(<FreeAppRedirect />)
        return components;
      }

      components.push(<TicketSubject        key='subject'
                                            preDefSubject={this.props.form && this.props.form.subject ? this.props.form.subject : ''}/>);

                                            components.push(<TicketCommentForm    key='comment'
                                              newTicket='true'
                                              showTitle='true'
                                              suggest='true'
                                              showMonitoringModal='true'
                                              label={this.props.form && this.props.form.body_label ? this.props.form.body_label : ''} />);

                                            components.push(
                                              <div key="timezone-phonenumber-container" className="bb b--light-silver flex flex-column flex-row-l pv4">
                                                <div className="w-100 w-30-l flex-shrink-0 pt1 pb2 pb0-l">
                                                  <label htmlFor="timezone" className="f4 dark-gray">
                                                  Preferred Contact Timezone:
                                                  </label>
                                                </div>
                                                <div className="flex-auto flex flex-column">
                                                  <select
                                                    name="ticket[timezone]"
                                                    id="timezone"
                                                    className="hk-input"
                                                    value={this.state.timezone}
                                                    onChange={(e) => this.updateState({ timezone: e.target.value })}
                                                    required
                                                  >
                                                    <option value="">Select Timezone</option>
                                                          <option value="(UTC-12:00) International Date Line West Etc/GMT+12">(UTC-12:00) International Date Line West Etc/GMT+12</option>
                                                          <option value="(UTC-11:00) Coordinated Universal Time-11 Etc/GMT+11">(UTC-11:00) Coordinated Universal Time-11 Etc/GMT+11</option>
                                                          <option value="(UTC-10:00) Hawaii Pacific/Honolulu">(UTC-10:00) Hawaii Pacific/Honolulu</option>
                                                          <option value="(UTC-09:00) Alaska America/Anchorage">(UTC-09:00) Alaska America/Anchorage</option>
                                                          <option value="(UTC-08:00) Baja California America/Santa_Isabel">(UTC-08:00) Baja California America/Santa_Isabel</option>
                                                          <option value="(UTC-08:00) Pacific Time (US and Canada) America/Los_Angeles">(UTC-08:00) Pacific Time (US and Canada) America/Los_Angeles</option>
                                                          <option value="(UTC-07:00) Chihuahua, La Paz, Mazatlan America/Chihuahua">(UTC-07:00) Chihuahua, La Paz, Mazatlan America/Chihuahua</option>
                                                          <option value="(UTC-07:00) Arizona America/Phoenix">(UTC-07:00) Arizona America/Phoenix</option>
                                                          <option value="(UTC-07:00) Mountain Time (US and Canada) America/Denver">(UTC-07:00) Mountain Time (US and Canada) America/Denver</option>
                                                          <option value="(UTC-06:00) Central America America/Guatemala">(UTC-06:00) Central America America/Guatemala</option>
                                                          <option value="(UTC-06:00) Central Time (US and Canada) America/Chicago">(UTC-06:00) Central Time (US and Canada) America/Chicago</option>
                                                          <option value="(UTC-06:00) Saskatchewan America/Regina">(UTC-06:00) Saskatchewan America/Regina</option>
                                                          <option value="(UTC-06:00) Guadalajara, Mexico City, Monterey America/Mexico_City">(UTC-06:00) Guadalajara, Mexico City, Monterey America/Mexico_City</option>
                                                          <option value="(UTC-05:00) Bogota, Lima, Quito America/Bogota">(UTC-05:00) Bogota, Lima, Quito America/Bogota</option>
                                                          <option value="(UTC-05:00) Indiana (East) America/Indiana/Indianapolis">(UTC-05:00) Indiana (East) America/Indiana/Indianapolis</option>
                                                          <option value="(UTC-05:00) Eastern Time (US and Canada) America/New_York">(UTC-05:00) Eastern Time (US and Canada) America/New_York</option>
                                                          <option value="(UTC-04:30) Caracas America/Caracas">(UTC-04:30) Caracas America/Caracas</option>
                                                          <option value="(UTC-04:00) Atlantic Time (Canada) America/Halifax">(UTC-04:00) Atlantic Time (Canada) America/Halifax</option>
                                                          <option value="(UTC-04:00) Asuncion America/Asuncion">(UTC-04:00) Asuncion America/Asuncion</option>
                                                          <option value="(UTC-04:00) Georgetown, La Paz, Manaus, San Juan America/La_Paz">(UTC-04:00) Georgetown, La Paz, Manaus, San Juan America/La_Paz</option>
                                                          <option value="(UTC-04:00) Cuiaba America/Cuiaba">(UTC-04:00) Cuiaba America/Cuiaba</option>
                                                          <option value="(UTC-04:00) Santiago America/Santiago">(UTC-04:00) Santiago America/Santiago</option>
                                                          <option value="(UTC-03:30) Newfoundland America/St_Johns">(UTC-03:30) Newfoundland America/St_Johns</option>
                                                          <option value="(UTC-03:00) Brasilia America/Sao_Paulo">(UTC-03:00) Brasilia America/Sao_Paulo</option>
                                                          <option value="(UTC-03:00) Greenland America/Godthab">(UTC-03:00) Greenland America/Godthab</option>
                                                          <option value="(UTC-03:00) Cayenne, Fortaleza America/Cayenne">(UTC-03:00) Cayenne, Fortaleza America/Cayenne</option>
                                                          <option value="(UTC-03:00) Buenos Aires America/Argentina/Buenos_Aires">(UTC-03:00) Buenos Aires America/Argentina/Buenos_Aires</option>
                                                          <option value="(UTC-03:00) Montevideo America/Montevideo">(UTC-03:00) Montevideo America/Montevideo</option>
                                                          <option value="(UTC-02:00) Coordinated Universal Time-2 Etc/GMT+2">(UTC-02:00) Coordinated Universal Time-2 Etc/GMT+2</option>
                                                          <option value="(UTC-01:00) Cape Verde Atlantic/Cape_Verde">(UTC-01:00) Cape Verde Atlantic/Cape_Verde</option>
                                                          <option value="(UTC-01:00) Azores Atlantic/Azores">(UTC-01:00) Azores Atlantic/Azores</option>
                                                          <option value="(UTC+00:00) Casablanca Africa/Casablanca">(UTC+00:00) Casablanca Africa/Casablanca</option>
                                                          <option value="(UTC+00:00) Monrovia, Reykjavik Atlantic/Reykjavik">(UTC+00:00) Monrovia, Reykjavik Atlantic/Reykjavik</option>
                                                          <option value="(UTC+00:00) Dublin, Edinburgh, Lisbon, London Europe/London">(UTC+00:00) Dublin, Edinburgh, Lisbon, London Europe/London</option>
                                                          <option value="(UTC+00:00) Coordinated Universal Time Etc/GMT">(UTC+00:00) Coordinated Universal Time Etc/GMT</option>
                                                          <option value="(UTC+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna Europe/Berlin">(UTC+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna Europe/Berlin</option>
                                                          <option value="(UTC+01:00) Brussels, Copenhagen, Madrid, Paris Europe/Paris">(UTC+01:00) Brussels, Copenhagen, Madrid, Paris Europe/Paris</option>
                                                          <option value="(UTC+01:00) West Central Africa Africa/Lagos">(UTC+01:00) West Central Africa Africa/Lagos</option>
                                                          <option value="(UTC+01:00) Belgrade, Bratislava, Budapest, Ljubljana, Prague Europe/Budapest">(UTC+01:00) Belgrade, Bratislava, Budapest, Ljubljana, Prague Europe/Budapest</option>
                                                          <option value="(UTC+01:00) Sarajevo, Skopje, Warsaw, Zagreb Europe/Warsaw">(UTC+01:00) Sarajevo, Skopje, Warsaw, Zagreb Europe/Warsaw</option>
                                                          <option value="(UTC+01:00) Windhoek Africa/Windhoek">(UTC+01:00) Windhoek Africa/Windhoek</option>
                                                          <option value="(UTC+02:00) Athens, Bucharest, Istanbul Europe/Istanbul">(UTC+02:00) Athens, Bucharest, Istanbul Europe/Istanbul</option>
                                                          <option value="(UTC+02:00) Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius Europe/Kiev">(UTC+02:00) Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius Europe/Kiev</option>
                                                          <option value="(UTC+02:00) Cairo Africa/Cairo">(UTC+02:00) Cairo Africa/Cairo</option>
                                                          <option value="(UTC+02:00) Damascus Asia/Damascus">(UTC+02:00) Damascus Asia/Damascus</option>
                                                          <option value="(UTC+02:00) Amman Asia/Amman">(UTC+02:00) Amman Asia/Amman</option>
                                                          <option value="(UTC+02:00) Harare, Pretoria Africa/Johannesburg">(UTC+02:00) Harare, Pretoria Africa/Johannesburg</option>
                                                          <option value="(UTC+02:00) Jerusalem Asia/Jerusalem">(UTC+02:00) Jerusalem Asia/Jerusalem</option>
                                                          <option value="(UTC+02:00) Beirut Asia/Beirut">(UTC+02:00) Beirut Asia/Beirut</option>
                                                          <option value="(UTC+03:00) Baghdad Asia/Baghdad">(UTC+03:00) Baghdad Asia/Baghdad</option>
                                                          <option value="(UTC+03:00) Minsk Europe/Minsk">(UTC+03:00) Minsk Europe/Minsk</option>
                                                          <option value="(UTC+03:00) Kuwait, Riyadh Asia/Riyadh">(UTC+03:00) Kuwait, Riyadh Asia/Riyadh</option>
                                                          <option value="(UTC+03:00) Nairobi Africa/Nairobi">(UTC+03:00) Nairobi Africa/Nairobi</option>
                                                          <option value="(UTC+03:30) Tehran Asia/Tehran">(UTC+03:30) Tehran Asia/Tehran</option>
                                                          <option value="(UTC+04:00) Moscow, St. Petersburg, Volgograd Europe/Moscow">(UTC+04:00) Moscow, St. Petersburg, Volgograd Europe/Moscow</option>
                                                          <option value="(UTC+04:00) Tbilisi Asia/Tbilisi">(UTC+04:00) Tbilisi Asia/Tbilisi</option>
                                                          <option value="(UTC+04:00) Yerevan Asia/Yerevan">(UTC+04:00) Yerevan Asia/Yerevan</option>
                                                          <option value="(UTC+04:00) Abu Dhabi, Muscat Asia/Dubai">(UTC+04:00) Abu Dhabi, Muscat Asia/Dubai</option>
                                                          <option value="(UTC+04:00) Baku Asia/Baku">(UTC+04:00) Baku Asia/Baku</option>
                                                          <option value="(UTC+04:00) Port Louis Indian/Mauritius">(UTC+04:00) Port Louis Indian/Mauritius</option>
                                                          <option value="(UTC+04:30) Kabul Asia/Kabul">(UTC+04:30) Kabul Asia/Kabul</option>
                                                          <option value="(UTC+05:00) Tashkent Asia/Tashkent">(UTC+05:00) Tashkent Asia/Tashkent</option>
                                                          <option value="(UTC+05:00) Islamabad, Karachi Asia/Karachi">(UTC+05:00) Islamabad, Karachi Asia/Karachi</option>
                                                          <option value="(UTC+05:30) Sri Jayewardenepura Kotte Asia/Colombo">(UTC+05:30) Sri Jayewardenepura Kotte Asia/Colombo</option>
                                                          <option value="(UTC+05:30) Chennai, Kolkata, Mumbai, New Delhi Asia/Kolkata">(UTC+05:30) Chennai, Kolkata, Mumbai, New Delhi Asia/Kolkata</option>
                                                          <option value="(UTC+05:45) Kathmandu Asia/Kathmandu">(UTC+05:45) Kathmandu Asia/Kathmandu</option>
                                                          <option value="(UTC+06:00) Astana Asia/Almaty">(UTC+06:00) Astana Asia/Almaty</option>
                                                          <option value="(UTC+06:00) Dhaka Asia/Dhaka">(UTC+06:00) Dhaka Asia/Dhaka</option>
                                                          <option value="(UTC+06:00) Yekaterinburg Asia/Yekaterinburg">(UTC+06:00) Yekaterinburg Asia/Yekaterinburg</option>
                                                          <option value="(UTC+06:30) Yangon Asia/Yangon">(UTC+06:30) Yangon Asia/Yangon</option>
                                                          <option value="(UTC+07:00) Bangkok, Hanoi, Jakarta Asia/Bangkok">(UTC+07:00) Bangkok, Hanoi, Jakarta Asia/Bangkok</option>
                                                          <option value="(UTC+07:00) Novosibirsk Asia/Novosibirsk">(UTC+07:00) Novosibirsk Asia/Novosibirsk</option>
                                                          <option value="(UTC+08:00) Krasnoyarsk Asia/Krasnoyarsk">(UTC+08:00) Krasnoyarsk Asia/Krasnoyarsk</option>
                                                          <option value="(UTC+08:00) Ulaanbaatar Asia/Ulaanbaatar">(UTC+08:00) Ulaanbaatar Asia/Ulaanbaatar</option>
                                                          <option value="(UTC+08:00) Beijing, Chongqing, Hong Kong, Urumqi Asia/Shanghai">(UTC+08:00) Beijing, Chongqing, Hong Kong, Urumqi Asia/Shanghai</option>
                                                          <option value="(UTC+08:00) Perth Australia/Perth">(UTC+08:00) Perth Australia/Perth</option>
                                                          <option value="(UTC+08:00) Kuala Lumpur, Singapore Asia/Singapore">(UTC+08:00) Kuala Lumpur, Singapore Asia/Singapore</option>
                                                          <option value="(UTC+08:00) Taipei Asia/Taipei">(UTC+08:00) Taipei Asia/Taipei</option>
                                                          <option value="(UTC+09:00) Irkutsk Asia/Irkutsk">(UTC+09:00) Irkutsk Asia/Irkutsk</option>
                                                          <option value="(UTC+09:00) Seoul Asia/Seoul">(UTC+09:00) Seoul Asia/Seoul</option>
                                                          <option value="(UTC+09:00) Osaka, Sapporo, Tokyo Asia/Tokyo">(UTC+09:00) Osaka, Sapporo, Tokyo Asia/Tokyo</option>
                                                          <option value="(UTC+09:30) Darwin Australia/Darwin">(UTC+09:30) Darwin Australia/Darwin</option>
                                                          <option value="(UTC+09:30) Adelaide Australia/Adelaide">(UTC+09:30) Adelaide Australia/Adelaide</option>
                                                          <option value="(UTC+10:00) Hobart Australia/Hobart">(UTC+10:00) Hobart Australia/Hobart</option>
                                                          <option value="(UTC+10:00) Yakutsk Asia/Yakutsk">(UTC+10:00) Yakutsk Asia/Yakutsk</option>
                                                          <option value="(UTC+10:00) Brisbane Australia/Brisbane">(UTC+10:00) Brisbane Australia/Brisbane</option>
                                                          <option value="(UTC+10:00) Guam, Port Moresby Pacific/Port_Moresby">(UTC+10:00) Guam, Port Moresby Pacific/Port_Moresby</option>
                                                          <option value="(UTC+10:00) Canberra, Melbourne, Sydney Australia/Sydney">(UTC+10:00) Canberra, Melbourne, Sydney Australia/Sydney</option>
                                                          <option value="(UTC+11:00) Vladivostok Asia/Vladivostok">(UTC+11:00) Vladivostok Asia/Vladivostok</option>
                                                          <option value="(UTC+11:00) Solomon Islands, New Caledonia Pacific/Guadalcanal">(UTC+11:00) Solomon Islands, New Caledonia Pacific/Guadalcanal</option>
                                                          <option value="(UTC+12:00) Coordinated Universal Time+12 Etc/GMT-12">(UTC+12:00) Coordinated Universal Time+12 Etc/GMT-12</option>
                                                          <option value="(UTC+12:00) Fiji, Marshall Islands Pacific/Fiji">(UTC+12:00) Fiji, Marshall Islands Pacific/Fiji</option>
                                                          <option value="(UTC+12:00) Magadan Asia/Magadan">(UTC+12:00) Magadan Asia/Magadan</option>
                                                          <option value="(UTC+12:00) Auckland, Wellington Pacific/Auckland">(UTC+12:00) Auckland, Wellington Pacific/Auckland</option>
                                                          <option value="(UTC+13:00) Nuku'alofa Pacific/Tongatapu">(UTC+13:00) Nuku'alofa Pacific/Tongatapu</option>
                                                          <option value="(UTC+13:00) Samoa Pacific/Apia">(UTC+13:00) Samoa Pacific/Apia</option>
                                                  </select>
                                                  {this.state.errors?.timezone && (
                                                    <p className="red mt2">{this.state.errors.timezone}</p>
                                                  )}
                                                </div>
                                              </div>
                                            );
                                            
                                            components.push(
                                              <div key="phonenumber-container" className="bb b--light-silver flex flex-column flex-row-l pv4">
                                                <div className="w-100 w-30-l flex-shrink-0 pt1 pb2 pb0-l">
                                                  <label htmlFor="phonenumber" className="f4 dark-gray">
                                                    Phone Number
                                                  </label>
                                                </div>
                                                <div className="flex-auto flex flex-column">
                                                  <input
                                                    type="text"
                                                    id="phonenumber"
                                                    name="ticket[phonenumber]"
                                                    className="hk-input"
                                                    placeholder="Enter your phone number"
                                                    value={this.state.ticket.phonenumber}
                                                    onChange={(e) =>
                                                      this.updateState({
                                                        ticket: { ...this.state.ticket, phonenumber: e.target.value },
                                                      })
                                                    }
                                                    pattern="^\+?[1-9]\d{1,14}$"
                                                  />
                                                  {this.state.errors?.phonenumber && (
                                                    <p className="red mt2">{this.state.errors.phonenumber}</p>
                                                  )}
                                                </div>
                                              </div>
                                            );
                                            
                                            
                                            
                                           
                                            
                                            
                                            
      if (this.props.allow_vip_priority) {
        components.push(<PrioritySelect     key='priority_select'
                                            form_type={this.state.form_type}
                                            permission_granted={this.state.permission_granted} />);
      }

      components.push(
        <div key='submit' className="flex pv4">
          <div className="w-30 dn flex-l flex-shrink-0 pt1" />
          <div className="flex-auto flex flex-column">
            <SubmitButton value={I18n.t('view.tickets.new.submit')} onClick={this.handleSubmit} />
          </div>
        </div>
      );

      return components;
    }
  }

  render () {
    var components = [];
    components.push(<input                type='hidden'
                                          name='ticket[category]'
                                          key='ticket[category]'
                                          value={this.state.category || this.props.breadcrumb.join(' > ')} />)

    if (this.props.appName) {
      components.push(<input              type='hidden'
                                          name='ticket[app_name]'
                                          key='ticket[app_name]'
                                          value={this.props.appName} />)
    }

    if (this.props.form && this.props.form.intro) {
      var intro = {__html: this.props.form.intro}
      components.push(
        <p key='intro' className='lh-copy f4 near-black mv3' dangerouslySetInnerHTML={intro} />
      );
    }

    if (this.formTypes()[this.state.form_type].app) {
      components.push(<ApplicationSelect  key='app_select'
                                          selectDatabase={this.formTypes()[this.state.form_type]._haddon}
                                          selectAddon={this.formTypes()[this.state.form_type]._3addon}
                                          required={this.formTypes()[this.state.form_type].required_app}
                                          getRunRate={this.getRunRate}
                                          updateState={this.updateState}
                                          />)
    }

    return (
      <React.Fragment>
      <TicketFormContext.Provider value={{
        app_name: this.state.app_name,
        current_macro_placement: this.state.current_macro_placement,
        macro_step: this.state.macro_step,
        macro_name: this.state.macro_name,
        reading_macro: this.state.reading_macro,
        macro_dismissed: this.state.macro_dismissed,
        dispatch: this.dispatch}}
      >
        {this.renderSubForm(components)}
        </TicketFormContext.Provider>
      </React.Fragment>
    );
  }
}

export default TicketForm